import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Select, Option } from 'barnyard/components';
import { getRegionsWithAccess, hasAllRegionsPermissions } from '~/app/corporate/core/selectors';

const RegionSelect = ({
  regions, hasAllPermissions, value, defaultDisplay, onChange, mode, onDeselect, allowClear, ...other
}) => {
  // We override the select/deselect behavior for multi-select
  // so that whenever "All regions" is selected, we can clear
  // the other values
  const props = (mode === 'multiple' && !allowClear) ? {
    onSelect: (val) => {
      if (val !== 0 && _.includes(value, 0)) {
        onChange([..._.pull(value, 0), val]);
      } else if (val === 0) {
        onChange([0]);
      } else {
        onChange(_.concat(value, val));
      }
    },
    onDeselect: (val) => {
      const valueWithoutVal = _.without(value, val);
      onChange(valueWithoutVal);
      if (onDeselect) {
        onDeselect(valueWithoutVal);
      }
    }
  } : { onChange };

  return (
    <Select
      value={value}
      mode={mode}
      allowClear={allowClear}
      {...props}
      {...other}
    >
      {!allowClear && hasAllPermissions && <Option value={0}>{defaultDisplay}</Option>}
      {_.map(regions, r => (
        <Option name={r.name} value={r.id} key={r.id}>{r.name}</Option>
      ))}
    </Select>
  );
};

const mapStateToProps = state => ({
  regions: getRegionsWithAccess(state),
  hasAllPermissions: hasAllRegionsPermissions(state)
});

RegionSelect.defaultProps = {
  defaultDisplay: 'All Regions',
  mode: 'multiple',
  optionFilterProp: 'name',
  allowClear: false,
};

RegionSelect.propTypes = {
  defaultDisplay: PropTypes.string,
  regions: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  mode: PropTypes.string,
  hasAllPermissions: PropTypes.bool,
  onDeselect: PropTypes.func,
  allowClear: PropTypes.bool,
};

export default connect(mapStateToProps)(RegionSelect);
